export enum MemberRole {
  COURIER = 'Courier',
  CUSTOMER = 'Customer',
  ADMIN = 'Admin',
  VENDOR = 'Vendor',
}
